import axios from 'axios';
import { useUserStore } from '@/components/user';
// 创建 Axios 实例
const instance = axios.create({
    baseURL: 'http://localhost:999', // 替换为你的 API 基础地址
    timeout: 5000, // 请求超时时间
});

// 请求拦截器
instance.interceptors.request.use(
    (config) => {
        // 检查是否是登录相关的请求
        if (!config.url.includes('/login')) {

            console.log('请求拦截器'+config.url)
            const userStore = useUserStore();

            console.log(('pina  里的userid'+userStore.userId))
            // 从 localStorage 或其他存储中获取 JWT Token
            const token = localStorage.getItem('authToken');
            const userInfo = JSON.parse(localStorage.getItem('userInfo'+userStore.userId));
            // userInfo 中存储 userID 和 organizationID
            if (token) {
                // 为每个非登录请求添加 Authorization 头
                config.headers.Authorization = `${token}`;
            }

            if (userInfo) {
                // 将 userID 和 organizationID 放入自定义请求头
                config.headers['X-User-ID'] = userInfo.userID;
                config.headers['X-Organization-ID'] = userInfo.organizationID;
            }

        }
        return config;
    },
    (error) => {
        // 请求错误处理
        return Promise.reject(error);
    }
);

// 响应拦截器
instance.interceptors.response.use(
    (response) => {
        // 请求成功，直接返回响应数据
        return response;
    },
    (error) => {
        // 响应错误处理
        if (error.response) {
            const { status } = error.response;

            // 根据状态码处理错误
            if (status === 401) {
                // 未授权，跳转到登录页面
                alert('登录状态已过期，请重新登录！');
                localStorage.removeItem('authToken'); // 清除 Token
                window.location.href = '/#/MGLogin'; // 跳转到登录页面
            } else if (status === 403) {
                alert('无权限访问，请联系管理员！');
            } else if (status >= 400 && status < 500) {
                alert('客户端请求错误，请检查后再试！');
            } else if (status >= 500) {
                alert('服务器发生错误，请稍后重试！');
            }
        } else {
            // 网络错误或其他未知错误
            alert('请求失败，请检查网络连接！');
        }
        return Promise.reject(error);
    }
);

export default instance;
